import { logWithOffset } from "../../logWithOffset";
let settings = null;

const isEnabled = () => {
  return typeof(settings.facebookAppId) === 'string' && settings.facebookAppId.length > 0;
};

const setup = async (s) => {
  settings = s;
  if (isEnabled()) {
    logWithOffset("Configuring Facebook");

    const effectiveId = typeof(settings.facebookPixelId) === 'string' && settings.facebookPixelId.length > 0 ? settings.facebookPixelId : settings.facebookAppId;
    logWithOffset(`Facebook Pixel ID: ${effectiveId}`);

    ! function(f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function() {
            n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
    }(window, document, 'script',
        'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', effectiveId, { external_id: settings.sessionId });
  }
};



const handlePageView = async (e) => {
  fbq('track', 'PageView', {}, { eventID: e.eventId });
};

const handleAcceptUpsell = async (e) => {
};

const handleCheckoutStarted = async (e) => {
};

const fire = async (e) => {
  if (!isEnabled()) {
    return;
  }

  switch(e.eventType) {
    case 'page_view':
      return handlePageView(e);
    case 'accepted_upsell':
      return handleAcceptUpsell(e);
    case 'checkout_started':
      return handleCheckoutStarted(e);
  }
};

export default { setup, fire };
